import { GridUtils } from '@/shared/util/grid-utils'
import { ShipmentsGridType } from '@/modules/shipments-module/components/grid/datasources/shipments-grid-datasource-factory'

export const shipmentsSidebarOptions = () => ({
    sideBarName: 'ShipmentsSideBar',
    expanded: [
        {
            id: 'internalShipments',
            label: 'shipments.sidebar.internalShipments',
            icon: ['fal', 'file-alt'],
            hasChildren: true,
            children: [
                {
                    id: 'shipmentsPendingToSend',
                    label: 'shipments.sidebar.send',
                    alticon: 'icon-box-send',
                    uicomponent: 'uicomponent.shipment.internal.pendingToSend',
                    data: {
                        gridType: ShipmentsGridType.PENDING_TO_SENT
                    },
                    hasChildren: false
                },
                {
                    id: 'shipmentsPendingToReceive',
                    label: 'shipments.sidebar.receive',
                    alticon: 'icon-box-receive',
                    uicomponent: 'uicomponent.shipment.internal.pendingToReceive',
                    data: {
                        gridType: ShipmentsGridType.PENDING_TO_RECEIVE
                    },
                    hasChildren: false
                },
                {
                    id: 'shipmentsSent',
                    label: 'shipments.sidebar.sent',
                    alticon: 'icon-order-send',
                    uicomponent: 'uicomponent.shipment.internal.sent',
                    data: {
                        gridType: ShipmentsGridType.SENT
                    },
                    hasChildren: true,
                    children: [
                        {
                            id: 'shipmentsSentToday',
                            label: 'global.dateTarget.today',
                            filterModel: {
                                'shipment.sendingDate': GridUtils.getTodayDateFilterModel()
                            }
                        },
                        {
                            id: 'shipmentsSentThisWeek',
                            label: 'global.dateTarget.thisWeek',
                            filterModel: {
                                'shipment.sendingDate': GridUtils.getThisWeekDateFilterModel()
                            }
                        },
                        {
                            id: 'shipmentsSentThisMonth',
                            label: 'global.dateTarget.thisMonth',
                            filterModel: {
                                'shipment.sendingDate': GridUtils.getThisMonthDateFilterModel()
                            }
                        }
                    ]
                },
                {
                    id: 'shipmentsReceived',
                    label: 'shipments.sidebar.received',
                    alticon: 'icon-order-receive',
                    uicomponent: 'uicomponent.shipment.internal.received',
                    data: {
                        gridType: ShipmentsGridType.RECEIVED
                    },
                    hasChildren: true,
                    children: [
                        {
                            id: 'shipmentsReceivedToday',
                            label: 'global.dateTarget.today',
                            filterModel: {
                                'receptionDate': GridUtils.getTodayDateFilterModel()
                            }
                        },
                        {
                            id: 'shipmentsReceivedThisWeek',
                            label: 'global.dateTarget.thisWeek',
                            filterModel: {
                                'receptionDate': GridUtils.getThisWeekDateFilterModel()
                            }
                        },
                        {
                            id: 'shipmentsReceivedThisMonth',
                            label: 'global.dateTarget.thisMonth',
                            filterModel: {
                                'receptionDate': GridUtils.getThisMonthDateFilterModel()
                            }
                        }
                    ]
                }
            ]
        }
    ],
    module: {
        icon: ['fal', 'box'],
        name: 'shipments.sidebar.shipments'
    }
})
